import { Typography } from "@mui/material";

export function NotFoundPage() {
    return <Typography variant="h6">Page not found</Typography>;
}
